import axios from "axios"
import { ApiRequest } from "./api-request"
import { ApiMethods, ERROR_MESSAGE } from "../utils/constants"

export async function saveUserData(data) {
  try {
    const response = await ApiRequest({
      url: "/user/register",
      method: ApiMethods.POST,
      data,
    })
    const responseData = response.data
    return responseData
  } catch (error) {
    return error
  }
}

export async function editUserData(data) {
  try {
    const response = await ApiRequest({
      url: "/user/update",
      method: ApiMethods.PUT,
      data,
    })
    const responseData = response.data
    return responseData
  } catch (error) {
    return error
  }
}

export async function changePassword(data) {
  try {
    const response = await ApiRequest({
      url: "/user/changePassword",
      method: ApiMethods.PUT,
      data,
    })
    const responseData = response.data
    return responseData
  } catch (error) {
    return error
  }
}

export async function getUsersData(data) {
  try {
    // await new Promise((res) => { setTimeout(() => { res() }, 2000) })

    const response = await ApiRequest({
      url: "/user/getAll",
      method: ApiMethods.GET,
      params: data,
    })
    const responseData = response.data

    console.log("response 12345", responseData)
    // await Promise((res) => setTimeout(() => res(), 1000))
    // const result = [{ name: "Ravi", password: "Test@123", role: "Doctor", profileUrl: "img", email: "ravi@gmail.com" }]
    // return { result }

    if (responseData.status === "Failure") {
      return { error: { message: responseData.message || ERROR_MESSAGE } }
    }
    return responseData.result

    return responseData
  } catch (error) {
    console.log("err", error)
    return { error }

    const result = [
      {
        name: "Ravi",
        password: "Test@123",
        role: "Doctor",
        profileUrl: "img",
        email: "ravi@gmail.com",
      },
    ]

    return { result }
  }
}

export async function getCommonUsersData(data) {
  try {
    // await new Promise((res) => { setTimeout(() => { res() }, 2000) })

    const response = await ApiRequest({
      url: "/patient/getAll",
      method: ApiMethods.GET,
      params: data,
    })
    console.log("response 123", response)
    // await Promise((res) => setTimeout(() => res(), 1000))
    // const result = [{ firstName: "Ravi", title: "Mr", password: "Test@123", role: "Doctor", profileUrl: "img", email: "ravi@gmail.com" }]
    // return { result }
    const result = response.data.result.userDetails
    return { result }
  } catch (error) {
    console.log("err", error)
    return { error }
  }
}

export async function getUsersByRole(data) {
  try {
    // await new Promise((res) => { setTimeout(() => { res() }, 2000) })

    const response = await ApiRequest({
      url: "/user/getUsersByRole",
      method: ApiMethods.GET,
      params: data,
    })
    const responseData = response.data

    console.log("response 12345", responseData)
    // await Promise((res) => setTimeout(() => res(), 1000))
    // const result = [{ name: "Ravi", password: "Test@123", role: "Doctor", profileUrl: "img", email: "ravi@gmail.com" }]
    // return { result }

    if (responseData.status === "Failure") {
      return { error: { message: responseData.message || ERROR_MESSAGE } }
    }
    return responseData.result

    return responseData
  } catch (error) {
    console.log("err", error)
    return { error }
  }
}

// patients
export async function getAllUsers(data) {
  try {
    // await new Promise((res) => { setTimeout(() => { res() }, 2000) })

    const response = await ApiRequest({
      url: "/patient/getAll",
      method: ApiMethods.GET,
      params: data,
    })
    const responseData = response.data

    console.log("response 12345", responseData)
    // await Promise((res) => setTimeout(() => res(), 1000))
    // const result = [{ name: "Ravi", password: "Test@123", role: "Doctor", profileUrl: "img", email: "ravi@gmail.com" }]
    // return { result }

    if (responseData.status === "Failure") {
      return { error: { message: responseData.message || ERROR_MESSAGE } }
    }
    return responseData.result

    return responseData
  } catch (error) {
    console.log("err", error)
    return { error }
  }
}
